"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AttendeeTile = require("./AttendeeTile");
Object.keys(_AttendeeTile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AttendeeTile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AttendeeTile[key];
    }
  });
});
var _AgoraAttendeeTile = require("./AgoraAttendeeTile");
Object.keys(_AgoraAttendeeTile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AgoraAttendeeTile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AgoraAttendeeTile[key];
    }
  });
});
var _Tile = require("./Tile");
Object.keys(_Tile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Tile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Tile[key];
    }
  });
});